import {
  createContext,
  FeedbackForm as FeedbackFormWidget,
  Provider,
  IContext,
  ETopic,
} from '@cian/feedback-form-widget';
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useTracking } from './hooks/useTracking';
import { useApplicationContext } from '../../utils/applicationContext';
import { selectUserBaseInfo } from '../../selectors/user';
import { selectExperiments } from '../../selectors/experiments';
import { selectDuplicateOfferLink } from '../../selectors/duplicateOfferLink';
import { selectTopic } from '../../selectors/topic';
import { selectReferenceLink } from '../../selectors/referenceLink';
import { selectPartnerRewardsSource } from '../../selectors/partnerRewardsSource';
import { useLayoutConfiguration } from './hooks/useLayoutConfiguration';
import { useEventsLog } from './hooks/useEventsLog';
import { setTopic } from '../../actions/topic';

export const FeedbackFormContainer: React.FC = () => {
  const dispatch = useDispatch();

  const { httpApi, logger, config } = useApplicationContext();
  const layoutConfiguration = useLayoutConfiguration();
  const user = useSelector(selectUserBaseInfo);
  const experiments = useSelector(selectExperiments);
  const duplicateOfferLink = useSelector(selectDuplicateOfferLink);
  const topic = useSelector(selectTopic);
  const partnerRewardsSource = useSelector(selectPartnerRewardsSource);
  const referenceLink = useSelector(selectReferenceLink);

  const widgetContext = React.useMemo<IContext>(
    () =>
      createContext(
        {
          httpApi,
          logger,
          config,
        },
        {
          email: user.email,
          name: user.firstName,
          phone: user.phone,
          withAgreement: !user.isAuthenticated,
          duplicateOfferLink,
          topic: topic || undefined,
          partnerRewardsSource: partnerRewardsSource || undefined,
          experiments,
          layoutConfiguration,
          referenceLink,
        },
      ),
    // необходимо обновлять контекст при обновлении топика фидбека
    // oxlint-disable-next-line react/exhaustive-deps
    [topic],
  );

  const handleOpenModal = React.useCallback(() => {
    widgetContext.openModal();
  }, [widgetContext]);

  const handleTopicUpdate = React.useCallback((topic: ETopic) => dispatch(setTopic({ topic })), [dispatch]);

  useEventsLog({ openModal: handleOpenModal, onTopicUpdate: handleTopicUpdate });
  useTracking(widgetContext);

  return (
    <Provider context={widgetContext}>
      <FeedbackFormWidget />
    </Provider>
  );
};
